import { MotionReveal } from '@/components/common/MotionReveal';
import { ZoomableImage } from '@/components/common/ImageLightbox';

const answers = [
  {
    question: 'Ko smo?',
    answer:
      'Tim poslovnih savetnika i projektnih koordinatora sa iskustvom u organizaciji promena i rada više učesnika.'
  },
  {
    question: 'Kako se uključujemo?',
    answer:
      'Preuzimamo ceo projekat ili tačno definisan deo: planiranje, koordinaciju, dokumentaciju ili praćenje realizacije.'
  },
  {
    question: 'Šta klijent dobija?',
    answer:
      'Jasan plan, redovan pregled napretka i jednu odgovornu kontakt osobu tokom saradnje.'
  }
];

export function WhoWeAreSection() {
  return (
    <section className="py-20 sm:py-26 lg:py-34">
      <div className="site-container grid gap-12 lg:grid-cols-[1.08fr_0.92fr] lg:items-start lg:gap-20">
        <MotionReveal>
          <figure>
            <ZoomableImage
              className="aspect-[4/4.1] w-full rounded-[var(--radius-md)] object-cover"
              src="https://images.unsplash.com/photo-1497366412874-3415097a27e7?auto=format&fit=crop&w=1500&q=86"
              alt="Sala za rad i razgovor sa klijentima"
              loading="lazy"
            />
            <figcaption className="mt-3 text-xs leading-5 text-text-muted">
              Radni prostor · Beograd
            </figcaption>
          </figure>
        </MotionReveal>

        <MotionReveal delay={0.05}>
          <p className="section-label">O Helmflexu</p>
          <h2 className="mt-3 text-balance text-3xl font-semibold tracking-[-0.04em] text-text-primary sm:text-4xl lg:text-[2.8rem] lg:leading-[1.1]">
            Iskustvo u planiranju, organizaciji i vođenju poslovnih projekata.
          </h2>
          <div className="mt-8 border-t border-border">
            {answers.map(item => (
              <article
                key={item.question}
                className="grid gap-2 border-b border-border py-5 sm:grid-cols-[0.32fr_0.68fr] sm:gap-6"
              >
                <h3 className="font-semibold text-text-primary">
                  {item.question}
                </h3>
                <p className="text-sm leading-6 text-text-secondary sm:text-base">
                  {item.answer}
                </p>
              </article>
            ))}
          </div>
        </MotionReveal>
      </div>
    </section>
  );
}
